import axios from 'axios'


function createError(data, status, popupOnError) {
    let err_msg = "תקלת שרת, אנא נסה שנית מאוחר יותר";
    if (data.err?.content) {
        err_msg = data.err?.content;
    }
    if (data.message) {
        err_msg = data.message
    }
    return {
        error: {
            popupOnError,
            status: status,
            data: err_msg,
        },
    }
}

const extendParams = (config) => {
    if( window.location.search) {
        const params = new URLSearchParams(window.location.search)
        config.params = {...Object.fromEntries(params.entries()), ...(config?.params || {})}
    }

    return config
}

const client = axios.create({
    baseURL: '//' + window.apiUrl,
    withCredentials: true,
    headers: {
        'x-xsrf-token': 1
    }
})

const cdn = axios.create({
    baseURL: '//' + window.cdnUrl,
    withCredentials: true,
    headers: {
        'x-xsrf-token': 1
    }
})

client.interceptors.request.use(extendParams)
cdn.interceptors.request.use(extendParams)


const shouldUseCdn = (method, url) => {
    return method === 'GET' &&
        window?.cdnUrl &&
        window?.GetMethods?.patterns?.some(p => new RegExp(p).test(url));
}
export const axiosBaseQuery = ({baseUrl = ''}) => {

    return async (options) => {
        let {url, method, data, params, headers, popupOnError=true} = options;
        try {
            method = method ? method.toUpperCase() : 'GET';
            let agent = client;

            if (!url.startsWith('http')) {
                url = (baseUrl + url).replaceAll('//', '/')
            }


            if (shouldUseCdn(method, url)) {
                agent = cdn
            }


            const response = await agent.request({
                url,
                method,
                data,
                params,
                headers,
            })

            if (!response.data.statusCode && !response.data.status) {
                return createError(response.data, response.status, popupOnError)
            }

            if (response.data.err) {
                return {
                    data: response.data.data,
                    error: {
                        ...response.data.err,
                        popupOnError: popupOnError,
                    },
                }
            }

            return {
                data: response.data.data,
                error: response.data.err,
            }
        } catch (e) {
            console.error(e)
            return createError(e.response.data, e.response.status, popupOnError)
        }
    }
}





